<!--
  A grant its agent's computer refused (`status: 'refused'`), on the PR card and in
  Settings alike: why, what it asked for, and Grant again, which sends it
  as it was. It reads nothing until then, so it shows no boxes to change.
  RelayThread points to this button by name. The refusal is the card's
  text, not an alert: the parent says what came of Grant again (its news
  line, where focus goes, as the button goes with the refusal).
-->
<script lang="ts">
  import type { RelayGrant } from '../api/relay';
  import { scopeText } from '../logic/relayText';
  interface Props {
    grant: Extract<RelayGrant, { status: 'refused' }>;
    /** The button's accessible name, naming the grant among its neighbours (as Revoke's does). */
    label: string;
    /** Changes are ignored (another being saved): aria-disabled, so a focused button keeps focus. */
    disabled?: boolean;
    onretry: () => void;
  }
  let { grant, label, disabled = false, onretry }: Props = $props();
</script>
<p class="setting-problem small refused">Its computer refused this grant: {grant.reason.replace(/[.\s]+$/, '')}. It asked to read {scopeText(grant.scope)}, and reads nothing here until it is granted again.</p>
<button class="btn small" aria-label={label} aria-disabled={disabled ? 'true' : undefined} onclick={() => { if (!disabled) onretry(); }}>Grant again</button>
<style>
  p { margin: 0; }
  .btn[aria-disabled='true'] { opacity: .45; cursor: default; }
</style>
